// import React from 'react';
// import { Card, Space, Tag, Typography } from 'antd';

// const { Text, Title } = Typography;

// const StatCard = ({ icon, title, value, subtitle, trend, trendDown, color }) => (
//   <Card style={{ borderRadius: '8px' }}>
//     <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px'}}>
//       <div
//         style={{
//           backgroundColor: `${color}10`,
//           color: color,
//           width: '40px',
//           height: '40px',
//           borderRadius: '8px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}
//       >
//         {icon}
//       </div>
//       {trend && <Tag color={trendDown ? 'red' : 'green'}>{trend}</Tag>}
//     </Space>
//     <Text type="secondary">{title}</Text>
//     <Title level={3} style={{ margin: '8px 0 0' }}>
//       {value}
//     </Title>
//     {subtitle && <Text type="secondary">{subtitle}</Text>}
//   </Card>
// );

// export default StatCard;


import React from 'react';
import { Card, Space, Tag, Typography } from 'antd';

const { Text, Title } = Typography;

const StatCard = ({ icon, title, value, subtitle, trend, trendDown, color }) => (
  <Card
    style={{
      borderRadius: '8px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
  >
    <div style={{ flexGrow: 1 }}>
      <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <div
          style={{
            backgroundColor: `${color}10`,
            color: color,
            width: 40,
            height: 40,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </div>
        {trend && <Tag color={trendDown ? 'red' : 'green'}>{trend}</Tag>}
      </Space>
      <Text type="secondary">{title}</Text>
      <Title level={3} style={{ margin: '8px 0 0' }}>{value}</Title>
      {/* Even if subtitle is empty, reserve space */}
      <Text type="secondary" style={{ visibility: subtitle ? 'visible' : 'hidden' }}>
        {subtitle || 'placeholder'}
      </Text>
    </div>
  </Card>
);

export default StatCard;
